import { Flex as ChakraFlex } from '@chakra-ui/layout';

export const Flex = ChakraFlex;
